(() => {
  const CONFIG = {
    addonVariantId: '43186427887734',
    triggerProductIds: [
      '7977683714166',
      '7731657146486'
    ],
    matchEligibleQuantity: true,
    debug: true,
    marketMap: {
        canada: {
          addonVariantId: '43186427887734',
          price: '$1299 CAD',
        },
        us: {
          addonVariantId: '43186427887734',
          price: '$899',
        },
      },
  };

  const SESSION_KEY = 'whiteGlovePromptHandled';

  function log(...args) {
    if (CONFIG.debug) {
      console.log('[WhiteGlove Cart]', ...args);
    }
  }

  function getCurrentMarketConfig() {
    const marketMap = CONFIG.marketMap || {};

    const country = window.Shopify?.country?.toUpperCase?.() || '';
    const currency = window.Shopify?.currency?.active?.toUpperCase?.() || '';

    if (country === 'CA' || currency === 'CAD') {
      return marketMap.canada || null;
    }

    if (country === 'US' || currency === 'USD') {
      return marketMap.us || null;
    }

    return marketMap.us || null;
  }

  function openModal(id) {
    const modal = document.getElementById(id);
    if (!modal) return;

    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('upsell-modal-open');
  }

  function closeModal(id) {
    const modal = document.getElementById(id);
    if (!modal) return;

    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('upsell-modal-open');
  }

  function wasPromptHandled() {
    return sessionStorage.getItem(SESSION_KEY) === '1';
  }

  function markPromptHandled() {
    sessionStorage.setItem(SESSION_KEY, '1');
  }

async function getCart() {
  const root = window.Shopify?.routes?.root || '/';

  const response = await fetch(
    `${root}cart.js?t=${Date.now()}`,
    {
      method: 'GET',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        Accept: 'application/json',
      },
    }
  );

  if (!response.ok) {
    throw new Error('Unable to load cart');
  }

  return response.json();
}

  function getWhiteGloveState(cart) {
    const addonVariantId = String(CONFIG.addonVariantId);
    const triggerProductIds = (CONFIG.triggerProductIds || []).map(String);

    const eligibleItems = (cart.items || []).filter((item) =>
      triggerProductIds.includes(String(item.product_id))
    );

    const hasEligibleProduct = eligibleItems.length > 0;

    const hasWhiteGloveAlready = (cart.items || []).some(
      (item) => String(item.variant_id) === addonVariantId
    );

    const eligibleQty = eligibleItems.reduce((total, item) => {
      return total + (Number(item.quantity) || 0);
    }, 0);

    const market = getCurrentMarketConfig();

    return {
      shouldPrompt: hasEligibleProduct && !hasWhiteGloveAlready,
      hasEligibleProduct,
      hasWhiteGloveAlready,
      eligibleQty,
      market
    };
  }



  let isSyncingWhiteGlove = false;

async function changeCartItem(itemKey, quantity) {
  const response = await fetch(
    window.Shopify.routes.root + 'cart/change.js',
    {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        id: itemKey,
        quantity: Number(quantity),
      }),
    }
  );

  if (!response.ok) {
    let error = {};

    try {
      error = await response.json();
    } catch (_) {}

    throw error;
  }

  return response.json();
}

async function syncWhiteGloveCart() {
  if (isSyncingWhiteGlove) return false;

  isSyncingWhiteGlove = true;

  try {
    let cart = await getCart();

    const addonVariantId = String(CONFIG.addonVariantId);
    const triggerProductIds = (CONFIG.triggerProductIds || []).map(String);

    const eligibleItems = cart.items.filter((item) =>
      triggerProductIds.includes(String(item.product_id))
    );

    const whiteGloveItems = cart.items.filter(
      (item) => String(item.variant_id) === addonVariantId
    );

    const eligibleQuantity = eligibleItems.reduce(
      (total, item) => total + Number(item.quantity || 0),
      0
    );

    const whiteGloveQuantity = whiteGloveItems.reduce(
      (total, item) => total + Number(item.quantity || 0),
      0
    );

    log('syncWhiteGloveCart', {
      eligibleQuantity,
      whiteGloveQuantity,
      whiteGloveItems,
    });

    /*
     * CASO 1:
     * Ya no hay productos elegibles.
     * Eliminar todas las líneas de White Glove.
     */
    if (eligibleQuantity === 0 && whiteGloveItems.length > 0) {
      for (const item of whiteGloveItems) {
        cart = await changeCartItem(item.key, 0);
      }

      /*
       * Permite volver a mostrar el modal si después
       * agregan nuevamente un producto elegible.
       */
      sessionStorage.removeItem(SESSION_KEY);

      log('White Glove removed because no eligible products remain');

      return true;
    }

    /*
     * CASO 2:
     * Todavía existen productos elegibles y la cantidad
     * de White Glove debe coincidir con ellos.
     */
    if (
      CONFIG.matchEligibleQuantity &&
      eligibleQuantity > 0 &&
      whiteGloveItems.length > 0 &&
      whiteGloveQuantity !== eligibleQuantity
    ) {
      const [firstWhiteGloveItem, ...duplicatedWhiteGloveItems] =
        whiteGloveItems;

      /*
       * Ajustar la primera línea de White Glove.
       */
      cart = await changeCartItem(
        firstWhiteGloveItem.key,
        eligibleQuantity
      );

      /*
       * Eliminar posibles líneas duplicadas.
       */
      for (const item of duplicatedWhiteGloveItems) {
        cart = await changeCartItem(item.key, 0);
      }

      log('White Glove quantity updated', eligibleQuantity);

      return true;
    }

    return false;
  } catch (error) {
    console.error(
      '[WhiteGlove Cart] syncWhiteGloveCart error:',
      error
    );

    return false;
  } finally {
    isSyncingWhiteGlove = false;
  }
}


  async function addWhiteGloveToCart(quantity) {
    log('addWhiteGloveToCart', quantity);

    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        items: [
          {
            id: Number(CONFIG.addonVariantId),
            quantity: Number(quantity) || 1,
          },
        ],
      }),
    });

    if (!response.ok) {
      let error = {};
      try {
        error = await response.json();
      } catch (_) {}
      throw error;
    }

    return response.json();
  }

  function updateWhiteGloveModalContent(rule) {
    console.log({rule});
    const priceEls = document.querySelectorAll('.price-upsell-glove-modal');
    console.log(priceEls);
    if (!priceEls.length) return;

    priceEls.forEach((el) => {
      el.textContent = rule.price || '$899';
    });
  }

  async function maybeOpenWhiteGloveModal() {
    try {
      const cart = await getCart();
      const state = getWhiteGloveState(cart);

      log('cart state', state);

      if (!state.shouldPrompt) return;
      if (wasPromptHandled()) {
        log('prompt already handled in this session');
        return;
      }
      updateWhiteGloveModalContent(state.market);
      openModal('whiteGloveModal');
    } catch (error) {
      console.error('[WhiteGlove Cart] maybeOpenWhiteGloveModal error:', error);
    }
  }

  async function onWhiteGloveYes() {
    try {
      const cart = await getCart();
      const state = getWhiteGloveState(cart);

      if (!state.shouldPrompt) {
        markPromptHandled();
        closeModal('whiteGloveModal');
        return;
      }

      const quantity = CONFIG.matchEligibleQuantity
        ? Math.max(1, state.eligibleQty)
        : 1;

      await addWhiteGloveToCart(quantity);

      markPromptHandled();
      closeModal('whiteGloveModal');

      window.location.reload();
    } catch (error) {
      console.error('[WhiteGlove Cart] error adding White Glove:', error);
    }
  }

  function onWhiteGloveNo() {
    markPromptHandled();
    closeModal('whiteGloveModal');
  }

  function onWhiteGloveClose() {
    markPromptHandled();
    closeModal('whiteGloveModal');
  }

  let cartSyncTimer = null;

function scheduleWhiteGloveSync(source) {
  clearTimeout(cartSyncTimer);

  cartSyncTimer = setTimeout(async () => {
    if (isSyncingWhiteGlove) return;

    log('Cart modification detected:', source);

    const cartWasChanged = await syncWhiteGloveCart();

    if (cartWasChanged) {
      window.location.reload();
    }
  }, 400);
}

function isCartModificationUrl(url) {
  return /\/cart\/(change|update|clear)(\.js)?(?:\?|$)/.test(
    String(url || '')
  );
}

  function watchCartRequests() {
  if (window.__whiteGloveWatcherInstalled) return;

  window.__whiteGloveWatcherInstalled = true;

  /*
   * Detectar llamadas mediante fetch().
   */
  const originalFetch = window.fetch;

  window.fetch = async function (...args) {
    const request = args[0];

    const url =
      typeof request === 'string'
        ? request
        : request?.url || String(request || '');

    const response = await originalFetch.apply(this, args);

    if (
      response.ok &&
      isCartModificationUrl(url) &&
      !isSyncingWhiteGlove
    ) {
      scheduleWhiteGloveSync(`fetch: ${url}`);
    }

    return response;
  };

  /*
   * Detectar llamadas mediante XMLHttpRequest.
   */
  const originalOpen = XMLHttpRequest.prototype.open;
  const originalSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (
    method,
    url,
    ...rest
  ) {
    this.__whiteGloveUrl = url;

    return originalOpen.call(
      this,
      method,
      url,
      ...rest
    );
  };

  XMLHttpRequest.prototype.send = function (...args) {
    this.addEventListener('load', () => {
      const url = this.__whiteGloveUrl;

      if (
        this.status >= 200 &&
        this.status < 300 &&
        isCartModificationUrl(url) &&
        !isSyncingWhiteGlove
      ) {
        scheduleWhiteGloveSync(`xhr: ${url}`);
      }
    });

    return originalSend.apply(this, args);
  };

  /*
   * Respaldo para botones de eliminar.
   */
  document.addEventListener(
    'click',
    (event) => {
      const removeButton = event.target.closest(
        [
          'cart-remove-button',
          '[data-cart-remove]',
          '[data-remove-item]',
          'a[href*="/cart/change"]',
          'button[name="remove"]',
          '.cart-remove',
          '.cart__remove',
        ].join(',')
      );

      if (removeButton) {
        scheduleWhiteGloveSync('remove button');
      }
    },
    true
  );

  /*
   * Respaldo para cambios de cantidad.
   */
  document.addEventListener(
    'change',
    (event) => {
      const quantityInput = event.target.closest(
        [
          'input[name="updates[]"]',
          'input[data-quantity-variant-id]',
          '.quantity__input',
          '[data-cart-quantity]',
        ].join(',')
      );

      if (quantityInput) {
        scheduleWhiteGloveSync('quantity input');
      }
    },
    true
  );

  log('Cart watcher installed');
}

  async function init() {
    log('init');

      /*
   * Esto debe ejecutarse antes de buscar el modal.
   */
  watchCartRequests();

  /*
   * Comprobar el carrito al cargar la página.
   * Esto también cubre temas que recargan la página
   * después de eliminar un producto.
   */
  const cartWasChanged = await syncWhiteGloveCart();

  if (cartWasChanged) {
    window.location.reload();
    return;
  }

    const modal = document.getElementById('whiteGloveModal');
    if (!modal) {
      log('whiteGloveModal not found');
      return;
    }

    document.getElementById('whiteGloveYesBtn')?.addEventListener('click', onWhiteGloveYes);
    document.getElementById('whiteGloveNoBtn')?.addEventListener('click', onWhiteGloveNo);

    document
      .querySelectorAll('[data-modal-close="whiteGloveModal"]')
      .forEach((el) => el.addEventListener('click', onWhiteGloveClose));

    maybeOpenWhiteGloveModal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();